document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-sw-editorial-next]');

  if (!trigger) return;

  const slider = document.getElementById(trigger.dataset.target);

  if (!slider) return;

  const maxScroll = slider.scrollWidth - slider.clientWidth;
  const nextScroll = slider.scrollLeft + slider.clientWidth * 0.85;

  slider.scrollTo({
    left: nextScroll >= maxScroll - 8 ? 0 : nextScroll,
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
  });
});
